import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { } from "../../store/actions";

import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {...props};
  }

  switchRoutes() {
    console.log("swithcRoutes")
    let user = JSON.parse(localStorage.getItem("authUser"));
    if(user) {
      let roleId;
      if (user && user.id.includes("ADMIN")) {
        roleId = "ADMIN00012323";
      } else if (user && user.id.includes("EMP")) {
        roleId = user.roleId;
      }
      switch (roleId) {
        case "ROLE0000008":
          this.state.history.push("/add-purchased-item");
          // window.location.reload();
          break;
        case "ROLE0000007":
          this.state.history.push("/user-dashboard");
          // window.location.reload();
          break;
        case "ROLE0000004":
          this.state.history.push("/machine-operator-dashboard");
          // window.location.reload();
          break;
        case "ROLE0000003":
          this.state.history.push("/filler-dashboard");
          // window.location.reload();
          break;
        case "ROLE0000002":
          this.state.history.push("/grader-dashboard");
          // window.location.reload();
          break;
        case "ROLE0000001":
          this.state.history.push("/data-entry-dashboard");
          // window.location.reload();
          break;
        default:
          this.state.history.push("/admin-dashboard");
          // window.location.reload();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="vertical-menu">
          <div className="navbar-brand-box">
            <div className="logo logo-dark">
              <span className="logo-sm">
                <img src="images/dashboard-images/Sidebar.png" alt="logo" onClick={() => this.switchRoutes()} height="15" />
              </span>
              <span className="logo-lg">
                <img src="images/dashboard-images/Sidebar.png" alt="logo" onClick={() => this.switchRoutes()} height="45" />
              </span>
            </div>

            <div className="logo logo-light">
              <span className="logo-sm">
                <img src="images/dashboard-images/Sidebar.png" alt="logo" onClick={() => this.switchRoutes()} height="15" />
              </span>
              <span className="logo-lg">
                <img src="images/dashboard-images/Sidebar.png" alt="logo" onClick={() => this.switchRoutes()} height="45" />
              </span>
            </div>
          </div>
          <div data-simplebar className="h-100">
            {this.props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
          </div>
          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    );
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
